// extracted by mini-css-extract-plugin
export default {"wrapper":"bB","noPadding":"cB","flavor_wrapper":"eB","flavor_button":"fB","vert":"gB","itemContent":"hB","itemName":"iB","blue":"jB","out_of_stock":"kB","newFlavorBadge":"lB","fullWidth":"mB","flavor_button_selected":"nB","black":"oB","attribute_wrapper":"pB","toggle_wrapper":"qB"};
    if(module.hot) {
      // 1721922364117
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  